(ns dre.pages.admin.client-download.db)

(def init-db
  {:loading? false})
